let model: any = null;
let currentOpenness = 0;
let isSpeaking = false;
let closeAnimationId: number | null = null;

const SMOOTHING_NEW = 0.6;
const SMOOTHING_OLD = 0.4;
const NOISE_GATE = 0.02;
const CLOSE_SPEED = 0.15;

export function setModel(live2dModel: any): void {
  model = live2dModel;
}

export function updateAmplitude(amplitude: number): void {
  if (!model) return;

  if (closeAnimationId !== null) {
    cancelAnimationFrame(closeAnimationId);
    closeAnimationId = null;
  }

  isSpeaking = true;
  const gated = amplitude < NOISE_GATE ? 0 : amplitude;
  const target = Math.min(1, Math.max(0, gated));

  currentOpenness = SMOOTHING_NEW * target + SMOOTHING_OLD * currentOpenness;

  applyMouth(currentOpenness);
}

export function stopSpeaking(): void {
  isSpeaking = false;
  animateClose();
}

function animateClose(): void {
  if (currentOpenness <= 0.01) {
    currentOpenness = 0;
    applyMouth(0);
    closeAnimationId = null;
    return;
  }

  currentOpenness *= (1 - CLOSE_SPEED);
  applyMouth(currentOpenness);
  closeAnimationId = requestAnimationFrame(animateClose);
}

function applyMouth(openness: number): void {
  if (!model) return;
  try {
    model.internalModel.coreModel.setParameterValueById('ParamMouthOpenY', openness);
  } catch {
    // Model may not be ready yet
  }
}

export function getCurrentOpenness(): number {
  return currentOpenness;
}
